import React from 'react';
import { number } from 'prop-types';
import NumberedCircle from 'components/NumberedCircle';
import deriveShopTagsFromFloor from 'utils/deriveShopTagsFromFloor.js';

ShopTags.propTypes = {
  rotate: number,
  floorLevel: number
};

function ShopTags({floorLevel, rotate}) {
  const [state, setState] = React.useState([]);

  React.useEffect(() => {
    const newState = deriveShopTagsFromFloor(floorLevel);
    setState(newState);
  }, [floorLevel]);
  
  return (
    <>
      {state.length && state.map(item => (
        <NumberedCircle key={item.id} rotate={rotate} cx={item?.cx} cy={item?.cy}>
          {item?.slotNumber}
        </NumberedCircle>
      ))}
    </>
  );
}

export default React.memo(ShopTags);